(ns hypnos.backoffice.tile.field.anatomy-eye-glass-indentations
  "Field for eye glass indentations."
  (:require [hypnos.i18n :refer [tr]]))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; field

(defn field
  ([state]
   (field state {:disabled false}))
  ([state {:keys [disabled] :or {disabled false}}]
   [:div.field.has-check.is-horizontal
    [:div.field-label.is-normal
     [:label.label (str (tr :ui.label/eye-glass-indentations))]]
    [:div.field-body
     [:div.field.is-grouped-multiline.is-grouped
      [:div.control
       [:label.b-radio.radio
        [:input.input {:type      :radio
                       :name      "eye-glass-indentations"
                       :disabled  disabled
                       :checked   (true? (get-in @state [:anatomy :anatomy/eye-glass-indentations?]))
                       :on-change (fn [e]
                                    (let [ new-value (when (-> e .-target .-checked) true)]
                                      (swap! state assoc-in
                                             [:anatomy :anatomy/eye-glass-indentations?]
                                             new-value)))}]
        [:span.check.is-info]
        [:span.control-label (tr :ui.label/yes)]]]
      [:div.control
       [:label.b-radio.radio
        [:input.input {:type      :radio
                       :name      "eye-glass-indentations"
                       :disabled  disabled
                       :checked   (when (not (nil? (get-in @state [:anatomy :anatomy/eye-glass-indentations?])))
                                    (false? (get-in @state [:anatomy :anatomy/eye-glass-indentations?])))
                       :on-change (fn [e]
                                    (let [new-value (when (-> e .-target .-checked) false)]
                                      (swap! state assoc-in
                                             [:anatomy :anatomy/eye-glass-indentations?]
                                             new-value)))}]
        [:span.check.is-info]
        [:span.control-label (tr :ui.label/no)]]]]]]))
